import { CollectClient } from "@tree-company/collect-js-client";
import CHARACTERS from "./characters";
import { DEFAULT_VALUES } from "./axes";
import { LANGUAGE } from "./locales";

let collectorURL = import.meta.env.VITE_COLLECTOR_URL;
if (collectorURL === undefined && import.meta.env.MODE === "development") {
  collectorURL = "http://localhost:3000";
}

// Setup client - we only need to do this once
const client = new CollectClient({
  url: collectorURL,
  projectKey: import.meta.env.VITE_COLLECTOR_KEY,
});

export function buildTreesponse(collectClient = client) {
  return collectClient.initTreesponse({
    language: LANGUAGE,
    initialAnswers: Object.fromEntries(
      CHARACTERS.map(({ key }) => [key, { ...DEFAULT_VALUES }]),
    ),
  });
}
